import React from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import {
  FacebookShareButton,
  TwitterShareButton,
} from 'react-share'

// Components
import PieChart from 'app/views/components/PieChart'

// Redux
import {
  getQuizById,
  getFriends,
  getQuizResults,
} from 'app/state/modules/quiz'

// Utils
import analytics from 'app/views/utils/analytics'


class QuizResults extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      quiz_is_done_grading: false,
    }
  }

  componentDidMount() {
    analytics.page('page-quiz-results')

    this.props.getQuizById(this.props.match.params.id)
    this.props.getFriends(this.props.currentQuizType)
    this.props.getQuizResults(this.props.match.params.id)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.results.my_score === null) {
      setTimeout(() => { this.props.getQuizResults(this.props.match.params.id) }, 3000)
    } else {
      this.setState({
        quiz_is_done_grading: true,
      })
    }
  }

  render() {
    return (
      <div>
        <div className="uk-cover-container uk-background-secondary uk-padding-large uk-padding-remove-bottom uk-padding-remove-top uk-light">
          <div className="uk-section uk-padding-remove-top uk-text-center">
            <Link to={`/quiz/${this.props.match.params.id}/results`}>
              <img src="/static/icons/test.png" style={{ height: 100 }} alt="test" />
              <h2>Quiz Results</h2>
            </Link>
          </div>
        </div>

        <div className="uk-container">
          <div className="uk-section uk-text-center">
            <h3 className="uk-text-bold">Scores</h3>
          </div>
          {(this.state.quiz_is_done_grading) ? (
            <div>
              <div className="uk-padding-small uk-section">
                <div>
                  {(this.props.quizStartedAt !== null) ? (
                    <div className="uk-text-center uk-grid uk-child-width-1-1 uk-child-width-1-3@s" data-uk-grid="">
                      <div>
                        <PieChart percentage={this.props.results.my_score} id={1} />
                        <h3 className="uk-margin-small">
                          My Score
                        </h3>
                      </div>
                      <div>
                        <PieChart percentage={this.props.results.avg_team_score} id={2} />
                        <h3 className="uk-margin-small">
                          Average Team Score
                        </h3>
                        <div><i>All { this.props.quizEmail.split('@')[1] } users</i></div>
                      </div>
                      <div>
                        <PieChart percentage={this.props.results.industry_average} id={3} />
                        <h3 className="uk-margin-small">
                          Industry Average
                        </h3>
                      </div>
                    </div>
                  ) : (
                    <div className="uk-text-center uk-grid uk-child-width-1-1 uk-child-width-1-2@s" data-uk-grid="">
                      <div>
                        <PieChart percentage={this.props.results.avg_team_score} id={2} />
                        <h3 className="uk-margin-small">
                          Team Score
                        </h3>
                        <div><i>All { this.props.quizEmail.split('@')[1] } users</i></div>
                      </div>
                      <div>
                        <PieChart percentage={this.props.results.industry_average} id={3} />
                        <h3 className="uk-margin-small">
                          Industry Average
                        </h3>
                      </div>
                    </div>
                  )}
                </div>
              </div>


              {(this.props.quizStartedAt !== null) &&
              <div className="uk-padding-small uk-width-large" style={{ margin: 'auto' }}>
                <h5 className="uk-text-bold uk-text-center">My Results</h5>
                <table className="uk-table uk-table-divider">
                  <tbody>
                    {Object.keys(this.props.results.my_answers).map(key => (
                      <tr key={key}>
                        <td>{key}</td>
                        <td>
                          {(this.props.results.my_answers[key] === true) ? (
                            <span role="img" aria-label="Thumbs Up">👍</span>
                          ) : (
                            <span role="img" aria-label="Thumbs Down">👎</span>
                          )}
                        </td>
                      </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              }

              {(this.props.quizStartedAt !== null) &&
              <div className="uk-padding-small uk-text-center">
                <h5 className="uk-text-bold">Share your score</h5>
                <div style={{ display: 'inline-block' }}>
                  <TwitterShareButton
                    url="https://hackedu.io/quiz"
                    title={`I scored a ${this.props.results.my_score} on the @hackedu Secure Coding IQ Assessment! What is your score?`}
                    style={{ float: 'left', paddingRight: 10 }}
                  >
                    <button className="uk-icon-button" data-uk-icon="icon: twitter" />
                  </TwitterShareButton>
                  <FacebookShareButton
                    url="https://hackedu.io/quiz"
                    quote={`I scored a ${this.props.results.my_score} on the @hackedu Secure Coding IQ Assessment! What is your score?`}
                    style={{ float: 'left', paddingRight: 10 }}
                  >
                    <button className="uk-icon-button" data-uk-icon="icon: facebook" />
                  </FacebookShareButton>
                </div>
              </div>
              }

            </div>
          ) : (
            <div className="uk-section uk-text-center uk-padding-remove-top">
              <div className="uk-text-center">
                <p className="uk-text-bold">
                  Please wait while we grade your quiz...
                </p>
                <div data-uk-spinner="" />
              </div>
            </div>
          )}
        </div>
        {(this.state.quiz_is_done_grading) &&
        <div className="uk-container">
          <div className="uk-section uk-text-center uk-padding-small">
            <h3 className="uk-text-bold">Challenge Co-Workers & Friends</h3>
            <p>
              Have your team sign up with their corporate email address and take the test at <a href="https://hackedu.io/quiz/take-the-test" target="_blank">https://hackedu.io/quiz/take-the-test</a> to see your company's results.
            </p>
            <Link
              to={`/quiz/${this.props.match.params.id}/invite`}
              className="uk-button tm-button-primary uk-button-primary"
            >
              Send Invites
            </Link>
          </div>
          <div className="uk-section uk-padding-remove-top">
            {(this.props.hasReceivedFriends) ? (
              <div>
                {(this.props.friends.length > 0) &&
                  <table className="uk-table uk-table-divider">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Score</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(this.props.friends).map(id => (
                        <tr key={id}>
                          <td>{this.props.friends[id].name}</td>
                          <td>{this.props.friends[id].email}</td>
                          <td>{(this.props.friends[id].score) ? (this.props.friends[id].score) : ('-')}</td>
                        </tr>
                        ))}
                    </tbody>
                  </table>
                }
              </div>
            ) : (
              <div className="uk-text-center">
                <p className="uk-text-bold">
                  Loading your friend's scores...
                </p>
                <div data-uk-spinner="" />
              </div>
            )}
          </div>
        </div>
        }
        <div className="uk-container uk-margin-large-bottom uk-text-center">
          <div className="uk-section uk-section-muted uk-padding uk-width-xxlarge" style={{ margin: 'auto' }}>
            <h3>Secure Development Training</h3>
            <div>
              <p>
                Learn more about our Secure Development Training for Developers
              </p>
              <Link
                to="/secure-development-training"
                className="uk-button uk-button-primary uk-button-large"
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.authenticationStatus === 'LOGGED_IN',
  results: state.quiz.results,
  currentQuizType: state.quiz.currentQuizType,
  hasReceivedFriends: state.quiz.hasReceivedFriends,
  friends: state.quiz.friends,
  quizStartedAt: state.quiz.quiz.started_at,
  quizEmail: state.auth.user.email,
})

const mapDispatchToProps = dispatch => ({
  getFriends: (quizTypeId) => { dispatch(getFriends(quizTypeId)) },
  getQuizById: (quizId) => { dispatch(getQuizById(quizId)) },
  getQuizResults: (quizId) => { dispatch(getQuizResults(quizId)) },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizResults))
